<template>
  <v-card outlined>
    <v-card-title>{{ schema == "edit" ? title : "" }}</v-card-title>
    <v-card-text>
      <v-form v-model="valid" ref="formEvent">
        <v-row class="mt-5">
          <v-col cols="8">
            <v-text-field label="Nombre" v-model="name" :rules="rulesName" />
          </v-col>

          <v-col cols="2">
            <v-switch label="Publico" v-model="isPublic" />
          </v-col>

          <v-col cols="12">
            <v-text-field
              prepend-inner-icon="mdi-calendar"
              label="Fecha inicial"
              v-model="start"
              readonly
            />
          </v-col>

          <v-col cols="12">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :rules="rulesEnd"
                  v-model="end"
                  label="Fecha final"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="end"
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="10">
            <v-select
              :rules="rulesColor"
              prepend-inner-icon="mdi-palette"
              label="Color"
              :items="colors"
              item-text="text"
              item-value="value"
              v-model="color"
            />
          </v-col>
          <v-col cols="2">
            <v-icon size="50" :color="color">mdi-circle</v-icon>
          </v-col>
          <v-col cols="12">
            <v-textarea outlined label="Descripcion" v-model="description" />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn
        :loading="loadingDelete"
        v-if="schema == 'edit'"
        text
        color="red"
        @click="deleteEvent"
        >eliminar evento</v-btn
      >
      <v-spacer />
      <v-btn
        text
        @click="schema == 'new' ? closeDialogEvent() : closeDialogEventShow()"
        >cancelar</v-btn
      >
      <v-btn
        text
        color="primary"
        @click="processEvent"
        :loading="loadingProcess"
      >
        {{ schema == "new" ? "guardar" : "editar" }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ["schema", "title", "start", "event", "click"],

  mounted() {
    if (this.event) {
      this.loadEventData();
    }
  },

  data() {
    return {
      isPublic: false,
      loadingDelete: false,
      loadingProcess: false,
      valid: false,
      description: "",
      name: "",
      color: "",
      end: null,
      menu2: false,
      colors: [
        { text: "BLUE", value: "blue" },
        { text: "INDIGO", value: "indigo" },
        { text: "DEEP-PURPLE", value: "deep-purple" },
        { text: "CYAN", value: "cyan" },
        { text: "GREEN", value: "green" },
        { text: "ORANGE", value: "orange" },
        { text: "GREY", value: "grey darken-1" },
      ],

      rulesName: [
        (value) => (value && value.length > 0) || "Ingrese el nombre",
      ],
      rulesEnd: [
        (value) => (value && value != null) || "Seleccione le fecha final",
      ],
      rulesColor: [
        (value) => (value && value.length > 0) || "Selecione el color",
      ],
    };
  },

  watch: {
    name(value) {
      this.name = value.toUpperCase();
    },

    click() {
      this.loadEventData();
    },
  },

  methods: {
    processEvent() {
      if (this.valid) {
        this.loadingProcess = true;
        setTimeout(() => {
          let payload = {
            is_public: this.isPublic,
            name: this.name,
            description: this.description,
            start: this.start,
            end: this.end,
            color: this.color,
          };

          let path =
            this.schema == "new" ? "storeEventAction" : "updateEventAction";

          if (this.schema == "edit") payload.id = this.event.id;

          this.$store
            .dispatch(path, payload)
            .then((res) => {
              this.schema == "new"
                ? this.$emit("addEvent", res)
                : this.$emit("editEvent", res);

              this.schema == "new"
                ? this.closeDialogEvent()
                : this.closeDialogEventShow();

              this.clearEvent();
              this.loadingProcess = false;
            })
            .catch(() => {
              this.loadingProcess = false;
            });
        }, 500);
      } else {
        this.$refs.formEvent.validate();
      }
    },

    clearEvent() {
      this.name = "";
      this.description = "";
      this.end = null;
      this.color = "";
      this.$refs.formEvent.resetValidation();
    },

    closeDialogEvent() {
      this.clearEvent();
      this.$emit("closeDialogEvent");
    },

    closeDialogEventShow() {
      this.clearEvent();
      this.$emit("closeDialogEventShow");
    },

    loadEventData() {
      this.isPublic = this.event.is_public;
      this.name = this.event.name;
      this.end = this.event.end;
      this.color = this.event.color;
      this.description = this.event.description;
    },

    deleteEvent() {
      this.$confirm({
        message: `Quieres eliminar este evento?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            this.loadingDelete = true;
            setTimeout(() => {
              this.$store
                .dispatch("deleteEventAction", this.event.id)
                .then(() => {
                  this.loadingDelete = false;
                  this.$emit("deleteEvent", this.event);
                  this.closeDialogEventShow();
                });
            }, 500);
          }
        },
      });
    },
  },
};
</script>

<style></style>
